<mat-progress-bar mode="indeterminate" class="w-full absolute z-index-3" *ngIf="filtersLoading && showLoader">
</mat-progress-bar>
<div *ngIf="!filtersLoading">
  <!-- Quick Filters -->

  <div class="pl-1 pr-1 quick-header relative w-full text-paragraph-old">{{ name ? name + ' ' : '' }}Views</div>

  <div class="pr-1 mt-2 mb-2" *ngIf="showDefault">
    <div class="text-gray-600 ml-1 pb-1 text-standard-old">Default</div>
    <y42-list-view-quick-filter
      *ngFor="let filter of defaultQuickFilters; trackBy: trackByID"
      [filter]="filter"
      [isDefaultFilter]="true"
      (setFilter)="setFilter(filter)"
    ></y42-list-view-quick-filter>
  </div>

  <div class="pr-1 pt-2" *ngIf="state.orgSpaceFilters?.length">
    <div class="text-gray-600 ml-1 pb-1 text-standard-old">Public</div>
    <y42-list-view-quick-filter
      *ngFor="let filter of state.orgSpaceFilters; let index = index; trackBy: trackByID"
      [filter]="filter"
      [index]="index"
      (setFilter)="setFilter(filter)"
      (editFilter)="editQuickFilter(filter, false)"
      (deleteFilter)="deleteQuickFilter(filter, false)"
    ></y42-list-view-quick-filter>
  </div>

  <div class="pr-1 border-top mt-2 pt-2" *ngIf="state.personalFilters?.length">
    <div class="text-gray-600 ml-1 pb-1">Private</div>
    <y42-list-view-quick-filter
      *ngFor="let filter of state.personalFilters; trackBy: trackByID"
      [filter]="filter"
      (setFilter)="setFilter(filter)"
      (editFilter)="editQuickFilter(filter, true)"
      (deleteFilter)="deleteQuickFilter(filter, true)"
    ></y42-list-view-quick-filter>
  </div>

  <!-- Edit Quick Filters / View -->

  <div class="mt-3 pl-1 pr-2 relative" *ngIf="canEdit">
    <button
      mat-stroked-button
      class="button-save-current-view pt-1 pb-1 pr-2 w-full fs-08 text-gray-700 font-normal bg-background-primary"
      style="line-height: 20px !important; min-width: auto; padding-left: 10px !important"
      (click)="addQuickFilter()"
    >
      Save Current View
    </button>
    <button
      mat-icon-button
      class="small-icon-button instruction-trigger"
      [mtxPopoverTriggerFor]="previewPic"
      [mtxPopoverTriggerOn]="'hover'"
      [intercomTarget]="'list-view-instruction-trigger'"
    >
      <fa-icon class="text-gray-600 fs-08" [icon]="['fal', 'info-circle']"></fa-icon>
    </button>
    <mtx-popover #previewPic="mtxPopover" [leaveDelay]="300" class="z-depth-1 bg-background-primary">
      <div class="instruction-preview-box">
        <img class="border-common mb-3" src="assets/images/quick-filter.png" width="180" />
        <div class="font-semibold fs-09">Instructions</div>
        <p class="fs-07">
          1. Apply a filter and/or a sorting<br />
          2. Save the active filters and/or sortings as a 'View' to quickly re-use it
        </p>
      </div>
    </mtx-popover>
  </div>
  <div class="pl-1 pr-2" *ngIf="showResetView">
    <button
      mat-stroked-button
      class="w-full mt-2 fs-08 text-gray-700 font-normal bg-background-primary"
      style="line-height: 20px !important; min-width: auto; padding-left: 10px !important"
      (click)="resetView.emit()"
    >
      <fa-icon class="fs-08" [icon]="['fal', 'power-off']"></fa-icon>&nbsp;&nbsp;Reset View
    </button>
  </div>
</div>
